import { Button, Checkbox, CircularProgress, FormControlLabel, Grid, Tooltip, Typography } from '@mui/material';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import { useEffect, useMemo, useState } from 'react';

import {
  EstadosActivacionInstallOTEnumChoice,
  EstadosOrdenTrabajoEnumChoice,
  gridSize,
  gridSizeMdLg10,
  gridSizeMdLg12,
  gridSizeMdLg2,
  gridSizeMdLg6,
  // gridSizeMdLg12,
  texto,
  useCheckPermissionsArray,
  // useLoaders,
} from '@/shared';
import { //changeIpv4Contrato, 
  useFetchCajasPrimarias, useFetchGetBras, useFetchOLTs, useGetContrato, useUpdateContrato, useUpdateOrdenTrabajo } from '@/shared/actions/erp';
import {
  // CustomAutocomplete,
  CustomAutocompleteNoForm,
  CustomTextField,
  CustomTextFieldNoForm,
  SingleIconButton,
} from '@/shared/components/ui';
import { SAVE_OT_PERMISSIONS_ACTIVACION } from '@/shared/constants/form-permissions';

// import { useFetchRouters } from '@/store/erp';
// import { useUiConfirmModalStore, useUiStore } from '@/store/ui';
import { OrdenTrabajo, Naps, PuertoNap, Contrato, EstadosNavegacionEnum, ONTOption, EstadoPuertoNap, Router } from '@/shared/interfaces';
// import { RenderFotosEntradaSalida } from '@/erp/tecnico/orden-trabajo/shared/components';
// import { useActivacionStore } from '@/store/erp/operaciones';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
// import { useQueryClient } from '@tanstack/react-query';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { Info, Person } from '@mui/icons-material';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { useFetchRouters } from '@/store/erp';
import CustomAutocompleteOptimized from '@/shared/components/ui/CustomAutocompleteOptimized';
import useSaveActivacion from '../../hooks/useSaveActivacion';
import { useUiConfirmModalStore, useUiStore } from '@/store/ui';
import { queryClient } from '@/shared/query-client/query-client';
import ModalProgressActivacion from './components/ModalProgressActivacion';
import OntClienteTrasladoDialog from '@/erp/operaciones/activaciones/traslados/shared/components/ont-cliente/OntClienteTrasladoDialog';
import CobroOntNuevaSection from '@/erp/operaciones/activaciones/traslados/shared/components/ont-cliente/CobroOntNuevaSection';
import AprovisionarTrasladoSection from '@/erp/operaciones/activaciones/traslados/shared/components/ont-cliente/AprovisionarTrasladoSection';
import { OntParaFormulario } from '@/erp/operaciones/activaciones/traslados/shared/components/ont-cliente/ont-cliente.actions';
import { CobroOntForm } from '@/erp/operaciones/activaciones/traslados/shared/components/ont-cliente/ont-cobro.actions';

export type DatosTecnicosFormComponentActivacionesProps = {
  // form: UseFormReturn<SaveFormDataActivacionInstallPendingOT>;
  form: UseFormReturn<any>;
  ordenTrabajo: OrdenTrabajo;
  isUpdatingPort?: boolean;
  isOnlyView?: boolean;
  napsByCity?: Naps[];
  isLoadingNapsByCity?: boolean;
  optionsONT?: ONTOption[]
  isloadingUbProducto?: boolean
  guardarBorrador?: any
  canChangeNap?: boolean
  setCanChangeNap?: React.Dispatch<React.SetStateAction<boolean>>
  /**
   * Permite cambiar NAP/Puerto/Router aunque el contrato ya esté ACTIVO. Lo usan
   * los TRASLADOS: el cliente ya navega y se lo mueve a otra NAP/puerto. En
   * instalaciones no se pasa (false) y todo sigue igual.
   */
  permitirCambioNapActivo?: boolean
  /**
   * Solo TRASLADOS: habilita buscar la ONT que el cliente ya tiene instalada.
   * El combo "ONT a Utilizar" solo ofrece el stock del tecnico, asi que en
   * clientes antiguos no aparece la ONT del domicilio. Instalaciones y visitas
   * no pasan estas props, por lo que su formulario queda igual.
   */
  permitirOntDelCliente?: boolean
  onOntClienteSeleccionada?: (ont: OntParaFormulario) => void
  /** Check "Usar ONT cliente": lo gobierna el contenedor, que es quien guarda. */
  usarOntCliente?: boolean
  onCambiarUsarOntCliente?: (v: boolean) => void
  /** Apertura del buscador, aparte del check: se cierra al elegir la ONT. */
  dialogoOntClienteAbierto?: boolean
  onCerrarDialogoOntCliente?: (huboSeleccion: boolean) => void
  /**
   * Cobro de la ONT entregada. Solo aplica cuando la ONT NO es la del cliente:
   * es el caso de que no conserve la suya y haya que venderle una del stock.
   */
  cobroOnt?: CobroOntForm | null
  onCambiarCobroOnt?: (v: CobroOntForm) => void
};


const DatosTecnicosFormComponentActivaciones: React.FC<
  DatosTecnicosFormComponentActivacionesProps
> = ({ form, ordenTrabajo, isOnlyView = false, 
  napsByCity, isLoadingNapsByCity, optionsONT=[], 
  isloadingUbProducto=false, guardarBorrador, canChangeNap, setCanChangeNap,
  permitirCambioNapActivo = false,
  permitirOntDelCliente = false, onOntClienteSeleccionada,
  usarOntCliente = false, onCambiarUsarOntCliente,
  dialogoOntClienteAbierto = false, onCerrarDialogoOntCliente,
  cobroOnt = null, onCambiarCobroOnt }) => {
  useCheckPermissionsArray(SAVE_OT_PERMISSIONS_ACTIVACION);
  const [routerKey, setRouterKey] = useState(0);
  const [
    openModalProgress,
    setOpenModalProgress
  ] = useState(false);
  const [estadoDeAprovisionamiento, setEstadoDeAprovisionamiento] = useState<{
    status: string;
    message: string;
    secondaryMessage?: string;
  }>({
    status: "",
    message: ""
  });

  // Flag propio del boton ACTIVAR/SUSPENDER: true SOLO mientras corre la
  // activacion. Asi el estado disabled no depende del refetch de la OT y, tras
  // un error, el boton se re-habilita para poder reintentar desde la UI.
  const [activando, setActivando] = useState(false);

  const watchEstadoNavegacion = useWatch({ control: form.control, name: 'estado_navegacion' });
  const watchPuertoEnNap = useWatch({ control: form.control, name: 'puertoEnNap' });
  const watchRawNap = useWatch({ control: form.control, name: 'rawNap' });
  const watchedPort = useWatch({ control: form.control, name: 'puerto' });
  const watchFechaUltimaActivacion = useWatch({ control: form.control, name: 'fecha_ultima_activacion' });
  const watchEstadoActivacion = useWatch({ control: form.control, name: 'estado_activacion' });
  const watchEquiposUtilizados = useWatch({ control: form.control, name: 'equipos_utilizados' });

  const estadoNavegacionCliente = watchEstadoNavegacion != EstadosNavegacionEnum.ACTIVO;
  // Traslado ya finalizado (Guardar y Finalizar -> GESTIONADA): la pantalla
  // queda en solo lectura; mismo criterio que ACTIVAR/Cambiar IPv4.
  const trasladoSellado = permitirCambioNapActivo
    && watchEstadoActivacion === EstadosActivacionInstallOTEnumChoice.GESTIONADA;
  // Traslado ya aprovisionado BIEN (semáforo verde: la fecha solo se escribe
  // cuando la activación termina con éxito): los botones de activar
  // desaparecen, igual que en instalaciones tras el 200, para no volver a
  // aprovisionar. Si la activación falla la fecha queda null y reaparecen.
  const trasladoAprovisionado = permitirCambioNapActivo && !!watchFechaUltimaActivacion;
  const PUERTO_CON_CLIENTE =
    watchPuertoEnNap?.estado == EstadoPuertoNap.OCUPADO ||
    watchPuertoEnNap?.estado == EstadoPuertoNap.EN_USO;

  const { errors } = form.formState;

  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(s => s.setConfirmDialogIsOpen);
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  
  const [openClienteContratoData, setOpenClienteContratoData] = useState(false);
  const [refreshOnt, setRefreshOnt] = useState(false);


  ///* fetch ------------------------
  const {
    data: dataClienteContrato,
    isLoading: isLoadingClienteContrato,
  } = useGetContrato(watchPuertoEnNap?.id_cliente_contrato, openClienteContratoData)


  const {
    data: cajasPrimariasPagingRes,
  } = useFetchCajasPrimarias({
    enabled: !!watchRawNap,
    params: useMemo(
      () => ({
        codigo: watchRawNap?.caja_primaria || form.getValues()?.nap_data,
      }),
      [watchRawNap?.caja_primaria, form]
    ),
  });

  const cajasPrimariasDataLength = cajasPrimariasPagingRes?.data?.data?.length || 0;
  const cajaPrimariaOltCodigo = useMemo(() => {
    const cajaPrimaria = watchRawNap?.caja_primaria || form.getValues('rawNap')?.caja_primaria;
    if (!cajaPrimaria) return undefined;

    return cajasPrimariasPagingRes?.data?.data?.find(x => x?.codigo == cajaPrimaria)?.olt;
  }, [cajasPrimariasPagingRes?.data?.data, watchRawNap?.caja_primaria, form]);

  const {
    data: oltsPagingRes,
  } = useFetchOLTs({
    enabled: cajasPrimariasPagingRes 
      && (cajasPrimariasDataLength > 0)
      && !!watchRawNap,
    params: useMemo(
      () => ({
        page_size: 700,
        codigo: cajaPrimariaOltCodigo,
      }),
      [cajaPrimariaOltCodigo]
    ),
  });
  const {
    data: routersPagingRes,
    isLoading: isLoadingRouters,
  } = useFetchRouters(
    useMemo(
      () => ({
        page_size: 700,
        olt: watchRawNap?.olt,
      }),
      [watchRawNap?.olt]
    ),
    !!watchRawNap
  );

  const {
    data: brasPagingRes,
  } = useFetchGetBras({
    enabled: (oltsPagingRes?.data?.data?.[0]?.es_bras ?? false),
    params: useMemo(
      () => ({
        codigo:
          oltsPagingRes?.data?.data?.[0]?.bras ||
          oltsPagingRes?.data?.data?.[0]?.bras_backup ||
          "",
      }),
      [
        oltsPagingRes?.data?.data?.[0]?.bras,
        oltsPagingRes?.data?.data?.[0]?.bras_backup,
      ]
    ),
  });

  const {
    cambiarIPv4,
  } = useSaveActivacion({ordenTrabajo, form})



  const setEstadoNavegacionContrato = useUpdateContrato<Pick<Contrato,"id_contrato"|"estado_navegacion">>({
    fetchRespMessage: true,
    enableSuccessAlert: false,
  });
  const updateOrdenTrabajo = useUpdateOrdenTrabajo<Pick<OrdenTrabajo,"fecha_ultima_activacion"|"equipos_utilizados">>({
    enableSuccessAlert:false,
    enableErrorRedirect:false,
    enableRedirect:false,
    enableErrorAlert:false,
    enableLoading:false
  });
  

  const changeStateNavigation = async (
    state: EstadosNavegacionEnum = EstadosNavegacionEnum.ACTIVO,
    manual = false
  ) => {
    setOpenModalProgress(true);
    setActivando(true);
    setEstadoDeAprovisionamiento({
      status: "STARTED",
      message: "Iniciando activación de cliente..."
    });
    const nowIso = dayjs().toISOString();

    if (!permitirCambioNapActivo && form.getValues()?.fecha_ultima_activacion !== nowIso) {
      form.setValue('fecha_ultima_activacion', nowIso);
    }

    setIsGlobalLoading(true);
    let estadoNavegacionFinal: EstadosNavegacionEnum | undefined = state;
    // TRASLADO: fecha del semáforo a persistir (undefined = no tocar).
    let fechaSemaforoTraslado: string | null | undefined = undefined;
    

    try {
      await updateOrdenTrabajo.mutateAsync({
        id: ordenTrabajo?.id_orden_trabajo!,
        data: {
          // TRASLADO: la fecha (semáforo) se persiste recién con el resultado.
          ...(permitirCambioNapActivo ? {} : { fecha_ultima_activacion: nowIso }),
          equipos_utilizados: form.getValues()?.equipos_utilizados,
        } as any,
      });
      setOpenModalProgress(true);
      setEstadoDeAprovisionamiento({
        status: "PROGRESS",
        message: "Vinculando cliente a OLT..."
      });
      await setEstadoNavegacionContrato.mutateAsync({
        id: ordenTrabajo?.contrato_data?.id_contrato!,
        data: {
          estado_navegacion: state,
          // La OT que se esta gestionando: con traslados el contrato tiene
          // varias OTs y el backend no debe adivinar con .first().
          ...(ordenTrabajo?.codigo
            ? { codigo_orden_trabajo: ordenTrabajo.codigo }
            : {}),
          ...(manual && {
            activacion_manual: true,
          })
        },
      },{
        onSuccess: (resp:any) => {
          console.log(resp)
          const message = resp?.message ??
            resp?.data?.message ??
            resp?.response?.data?.message ??
            "Proceso ejecutado con éxito.";
          const responseStatus = `${resp?.status ?? ""}`.toLowerCase();
          const warningCode = resp?.warning_code
            ?? resp?.data?.warning_code
            ?? resp?.response?.data?.warning_code;
          const isEmailWarning = responseStatus === "warning"
            && warningCode === "EMAIL_SEND_FAILED";
          const rollback = resp?.external?.rollback
            ?? resp?.data?.rollback
            ?? resp?.data?.data?.rollback;
          const estadoNavegacionRespuesta = responseStatus === "warning"
            ? rollback?.estado_navegacion
            : state;
          estadoNavegacionFinal = estadoNavegacionRespuesta;

          if (rollback?.attempted) {
            if (rollback?.success) {
              toast.warn('Se ejecutó la cancelación en OLT por fallo en tickets/provisionamiento.');
            } else {
              toast.error('No se pudo confirmar la cancelación en OLT. Revise manualmente.');
            }
          }
          
          setEstadoDeAprovisionamiento({
            status: isEmailWarning
              ? "SUCCESS_WITH_EMAIL_WARNING"
              : responseStatus === "warning"
              ? "WARNING"
              : state == EstadosNavegacionEnum.SUSPENDIDO ? "SUCCESS_1" : "SUCCESS",
            message: isEmailWarning
              ? "Cliente activado correctamente."
              : message,
            secondaryMessage: isEmailWarning
              ? "No se pudo enviar el correo de bienvenida."
              : undefined,
          });

          if (estadoNavegacionRespuesta
            && form.getValues()?.estado_navegacion !== estadoNavegacionRespuesta) {
            form.setValue('estado_navegacion', estadoNavegacionRespuesta);
          }

          // TRASLADO: semáforo. Éxito real → fecha (verde, en vivo);
          // warning (hubo rollback) → se limpia (rojo). La persistencia se
          // hace esperada más abajo, ANTES de invalidar la OT: si el refetch
          // le ganaba al PUT, el reset del form (effect [ordenTrabajo])
          // devolvía el semáforo a rojo hasta recargar la página.
          if (permitirCambioNapActivo) {
            fechaSemaforoTraslado = responseStatus === "warning" ? null : nowIso;
            form.setValue('fecha_ultima_activacion', fechaSemaforoTraslado);
          }
        },
        onError: (resp:any) => {
          console.log(resp)
          const responseData = resp?.response?.data;
          const responseStatus = `${responseData?.status ?? ""}`.toLowerCase();
          const message = resp?.external
            ? resp.external.mensaje
            : responseData?.message
            ? `${responseData.message}.`
            : "Error en el proceso ejecutado."
          
          setEstadoDeAprovisionamiento({
            status: responseStatus === "warning" ? "WARNING" : "FAILURE",
            message: message
          });

          // TRASLADO: activación fallida → semáforo en rojo (fecha fuera).
          if (permitirCambioNapActivo) {
            form.setValue('fecha_ultima_activacion', null);
            updateOrdenTrabajo.mutate({
              id: ordenTrabajo?.id_orden_trabajo!,
              data: { fecha_ultima_activacion: null } as any,
            });
          }
        }
      });

      if (estadoNavegacionFinal
        && form.getValues()?.estado_navegacion !== estadoNavegacionFinal) {
        form.setValue('estado_navegacion', estadoNavegacionFinal);
      }

      // TRASLADO: persistir el semáforo ANTES de invalidar, así el refetch
      // ya trae la fecha y el reset del form lo deja verde sin recargar.
      if (permitirCambioNapActivo && fechaSemaforoTraslado !== undefined) {
        try {
          await updateOrdenTrabajo.mutateAsync({
            id: ordenTrabajo?.id_orden_trabajo!,
            data: { fecha_ultima_activacion: fechaSemaforoTraslado } as any,
          });
        } catch (e) {
          // Si falla, el refetch repone el estado real guardado.
          console.error('No se pudo persistir el semáforo del traslado', e);
        }
      }

      queryClient.invalidateQueries({
        queryKey: ['orden-trabajo', ordenTrabajo?.id_orden_trabajo],
      });

      return true;
    } catch (error) {
      toast.error('Por favor, intente nuevamente');
      return false;
    } finally {
      setActivando(false);
      await setIsGlobalLoading(false);
    }
  };



  const procesoActivacion = (manual=false) =>{
    if(!!!form.getValues()?.fecha_hora_inicio_instalacion){
      return toast.error(texto.orden_trabajo_no_iniciada)
    }
    if(oltsPagingRes?.data?.data?.[0]?.migrado 
      && (
        !form.getValues()?.ssid || 
        !form.getValues()?.password_wifi
      ) && !manual){
      return toast.error("El ssid y la contraseña son obligatorios para la activación automática. Comuníquese con el técnico para que complete la información.",{
        autoClose: 8000
      })
    }
    if(!form.getValues()?.ipv4_actual){
      return toast.error("Debe asignar una IP antes de continuar")
    }
    if(!form.getValues()?.campos_completados){
      toast.error("Debe completar todos los DATOS TÉCNICOS para realizar la activación/suspension")
      return
    }
    // TRASLADO: la fecha de última activación es el semáforo (verde solo si
    // la activación TERMINA bien); la escribe changeStateNavigation al
    // confirmar el resultado. Instalaciones: igual que antes.
    form.reset({
      ...form.getValues(),
      fecha_ultima_activacion: permitirCambioNapActivo
        ? (form.getValues()?.fecha_ultima_activacion ?? null)
        : dayjs()
    })
    if(guardarBorrador){
      form.setValue("es_borrador",true)
      guardarBorrador(form.getValues(), false)
    } 
    // Traslado (permitirCambioNapActivo): el cliente ya está ACTIVO pero hay que
    // volver a aprovisionarlo en la NAP/puerto/ONT nuevos, así que el botón
    // siempre ACTIVA (nunca suspende). Instalaciones: igual que antes.
    if(estadoNavegacionCliente || permitirCambioNapActivo){
      changeStateNavigation(EstadosNavegacionEnum.ACTIVO,manual)
    }else{
      changeStateNavigation(EstadosNavegacionEnum.SUSPENDIDO,manual)
    }
    setCanChangeNap && setCanChangeNap(false)
  }

  // const changeStateNavigation = async (state:EstadosNavegacionEnum=EstadosNavegacionEnum.ACTIVO) => {
  //   const nowIso = dayjs().toISOString();
  //   if (form.getValues()?.fecha_ultima_activacion !== nowIso) {
  //     form.setValue('fecha_ultima_activacion', nowIso);
  //   }
  //   try {
  //     setIsGlobalLoading(true);
  //     await updateOrdenTrabajo.mutateAsync({
  //         id:ordenTrabajo?.id_orden_trabajo!,
  //         data:{
  //           fecha_ultima_activacion: nowIso,
  //           equipos_utilizados:form.getValues()?.equipos_utilizados
  //         }
  //       },
  //       {
  //         onSuccess : async () => {
  //           setIsGlobalLoading(true);
  //           await setEstadoNavegacionContrato.mutateAsync({
  //             id:ordenTrabajo?.contrato_data?.id_contrato!,
  //             data:{
  //               estado_navegacion:state,
  //             }
  //           },
  //           {
  //             onSuccess:() => {
  //               if (form.getValues()?.estado_navegacion !== state) {
  //                 form.setValue("estado_navegacion",state)
  //               }
  //             },
  //             onError: () => {
  //               toast.error("Por favor, intente nuevamente")
  //             },
  //             onSettled: () => {
  //               setIsGlobalLoading(false);
  //             }
  //           }
  //         )
  //           queryClient.invalidateQueries({
  //             queryKey: ["orden-trabajo", ordenTrabajo?.id_orden_trabajo],
  //           })
  //         },
  //         onError: () => {
  //           toast.error("Por favor, intente nuevamente")
  //         },
  //         onSettled: () => {
  //           setIsGlobalLoading(false);
  //         }
  //       }
  //     )
      
  //   } catch (error) {
  //     toast.error("En espera de validación esquema MikroTik")
  //     return false
  //   }

  //   return true
  // }

  useEffect(() => {
    const olt = oltsPagingRes?.data?.data?.[0];
    if (!olt) return;

    form.setValue("es_bras", olt.es_bras ?? false);
    form.setValue("bras", olt.bras ?? null);
    form.setValue("nodo", olt.nodo ?? null);
  }, [oltsPagingRes?.data?.data?.[0]?.id_olt])


  if (
    !ordenTrabajo?.id_orden_trabajo
  )
    return null;
  if (isloadingUbProducto) return <Grid {...gridSizeMdLg12} container item justifyContent="center"><CircularProgress/></Grid>;

  return (
    <>

      {/* ------- edit --------- */}

      {/* <TabTextLabel text="ACTIVACIÓN" pt="30px" /> */}
      {
        oltsPagingRes?.data?.data?.[0]?.es_bras ?
          <CustomAlertCard
            alertColor='info'
            alertTitle="Nota"
            alertMessage={texto.notificacion_es_bras}
            bgColorAlert="GREEN" />
          :
          <CustomAlertCard
            alertColor='info'
            alertTitle="Nota"
            alertMessage={texto.notificacion_es_router}
            bgColorAlert="SKY" />
      }
      {
        oltsPagingRes?.data?.data?.[0]?.migrado ?
          <CustomAlertCard
            alertColor="warning"
            alertTitle="OLT MIGRADA"
            alertMessage={texto.olt_migrada}
            bgColorAlert="WHITE" />
          :
          <CustomAlertCard
            alertColor="warning"
            alertTitle="OLT NO MIGRADA"
            alertMessage={texto.olt_no_migrada}
            bgColorAlert="WHITE" />
      }




      {/* ----------- Change NODO/OLT ----------- */}
      <Grid item container xs={12} alignItems="center" spacing={2}>

        <Grid item xs={12} md={6} container alignItems="center">
        </Grid>
      </Grid>

      {/* ----------- NAP and Port ----------- */}
      <Grid
        item
        container
        xs={12}
        alignItems="center"
        spacing={2}
      >
        <Grid item xs={12} md={6}>
          <CustomAutocompleteNoForm<Partial<Naps>>
            label="Nap"
            value={form.getValues().rawNap}
            // name="ont_a_utilizar"
            valueKey="nombre"
            actualValueKey="codigo"
            options={napsByCity || []}
            onChangeValue={value=>{
              form.setValue('nap',value)
            }}
            onChangeRawValue={value => {
              form.reset({
                ...form.getValues(),
                nap: value?.codigo,
                rawNap: value,
                puerto: null,
                router: null,
                ipv4_actual: null,
              })
            }}
            isLoadingData={isLoadingNapsByCity}
            defaultValue={form.getValues()?.nap || ""}
            size={gridSizeMdLg12}
            // disableClearable
            disabled={
              !canChangeNap || isOnlyView
              || (watchEstadoNavegacion==EstadosNavegacionEnum.ACTIVO && !permitirCambioNapActivo)?
              // || ordenTrabajo?.contrato_data?.estado_navegacion==EstadosNavegacionEnum.ACTIVO?
              true:
              false
            }
          />
        </Grid>

        <Grid {...gridSizeMdLg6} item container alignItems="center">
          <Grid item xs={12} md={10}>
            {!canChangeNap ? (
              <CustomTextFieldNoForm
                label="Puerto"
                value={watchedPort || ''}
                disabled
                size={gridSize}
              />
            ) : (
              <>
                <CustomAutocompleteOptimized<PuertoNap>
                  label="Puerto"
                  name="puerto"
                  valueKey="puerto"
                  actualValueKey="puerto"
                  options={
                    form.getValues()?.rawNap?.puertos?.map?.(
                      (puerto:PuertoNap) => puerto) || []
                  }
                  defaultValue={
                    ordenTrabajo?.puerto?.toString() || ''
                  }
                  onChangeValue={puerto => {
                    form.reset({
                      ...form.getValues(),
                      puertoEnNap: form.getValues()?.rawNap?.puertos?.find(
                        (puertoDeNap:PuertoNap)=>puertoDeNap.puerto==puerto
                      )
                    })
                  }}
                  disabled={!canChangeNap}
                  isLoadingData={false}
                  // validation
                  control={form.control}
                  error={errors.puerto as any}
                  helperText={errors.puerto?.message as any}
                  size={gridSizeMdLg12}
                  disableClearable
                />
                
              </>
            )}
          </Grid>

          <Grid item xs={12} md={1}>
            { watchedPort 
            && <SingleIconButton
              startIcon={
                  PUERTO_CON_CLIENTE?
                  <Person/>:
                  <Info/>
              }
              onClick={()=>{
                if(PUERTO_CON_CLIENTE){
                  setOpenClienteContratoData(true)
                }
              }}
              disabled={trasladoSellado
                || (PUERTO_CON_CLIENTE && !watchPuertoEnNap?.id_cliente_contrato)}
              color={PUERTO_CON_CLIENTE ? 'primary' : 'success'}
              label={
                PUERTO_CON_CLIENTE ? 'Puerto Asignado a Cliente' : 'Puerto Disponible'
              }
            />}
          </Grid>

          <Grid item xs={12} md={1}>
            <SingleIconButton
              startIcon={<ChangeCircleIcon />}
              color={!canChangeNap ? 'primary' : 'warning'}
              disabled={
                // Traslado ya finalizado (GESTIONADA): queda en solo lectura.
                trasladoSellado ? true :
                // Instalaciones: solo con el cliente aún no activo. Traslados:
                // siempre (el cliente ya está ACTIVO y cambia de NAP/puerto).
                !estadoNavegacionCliente && !permitirCambioNapActivo?
                true:
                false
              }
              label={
                canChangeNap ? 'Cancelar' : 'Cambiar NAP/Puerto/Router'
              }
              onClick={() => {
                // if cancel set puerto to default
                if (canChangeNap) {
                  form.reset({
                    ...form.getValues(),
                    puerto: ordenTrabajo?.puerto?.toString() || '',
                    distancia: ordenTrabajo?.distancia || '',
                    nap: ordenTrabajo?.nap?.toString() || '',
                    rawNap: ordenTrabajo?.nap_data || {},
                  });
                }else{
                  form.setValue("puerto","")
                }

                setCanChangeNap && setCanChangeNap(
                  canChangeNap ? false : !canChangeNap
                );
              }}
            />
          </Grid>
        </Grid>
      </Grid>

      {/* campo "caja_pimaria" mal escrito en el back, se niega la solicitud de rename por cambios encolados
      corregir cuando se pueda */}
      <CustomTextFieldNoForm
        label="Caja Primaria"
        value={
          cajasPrimariasPagingRes?.data?.data?.filter(
            x=>x?.codigo==form.getValues('rawNap')?.caja_primaria)
          ?.[0]?.nombre
          || 'N/D'
        }
        size={gridSizeMdLg6}
        disabled={true}
      />
      <CustomTextFieldNoForm
        label="OLT"
        value={oltsPagingRes?.data?.data?.[0]?.nombre || 'N/D'}
        size={gridSizeMdLg6}
        disabled={true}
      />
      {
        // canChangeNap ?
        oltsPagingRes?.data?.data?.[0]?.es_bras?
        <>
          <CustomTextFieldNoForm
            label="BRAS"
            value={brasPagingRes?.data?.data?.[0]?.nombre || 'N/D'}
            size={gridSizeMdLg6}
            disabled={true}
          />
        </>
        :<CustomAutocompleteOptimized<Router>
          size={gridSizeMdLg6}
          label={"Router"}
          name="router"
          // options
          options={routersPagingRes?.data?.data || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues()?.router||""}
          textFieldKey={`router-${routerKey}-${routersPagingRes?.data?.data?.length || 0}`}
          isLoadingData={isLoadingRouters}
          disabled={canChangeNap? !(form.getValues()?.nap && form.getValues()?.puerto): true}
          // validation
          control={form.control}
          error={form.formState.errors.router as any}
          infoText={"Llene los DATOS TÉCNICOS para habilitar"}
          helperText={form.formState.errors.router?.message as any}
          // disabled={form.getValues()?.estado_activacion==EstadosActivacionInstallOTEnumChoice.GESTIONADA?true:false}
          onChangeRawValue={(raw)=>{
            // if(raw?.codigo==ordenTrabajo?.router){
            //   return;
            // }
            if(!!raw){
              setConfirmDialog({
                isOpen: true,
                subtitle: texto.advertencia_cambio_router,
                title: "¿Está seguro que desea cambiar el router asignado?",
                onConfirm: async() => {
                  setConfirmDialogIsOpen(false);
                  form.setValue("es_borrador",true)
                  form.setValue("olt",oltsPagingRes?.data?.data?.[0]?.codigo)
                  try {
                    if(!form?.getValues()?.campos_completados){
                      form.reset({
                        ...form.getValues(),
                        router: null,
                      })
                      throw new Error("Debe completar todos los DATOS TÉCNICOS para seleccionar el router")
                    }
                    await guardarBorrador(form.getValues(), false);
                    await cambiarIPv4();
                    setCanChangeNap && setCanChangeNap(false)
                  } catch (error:any) {
                    console.error("Error detectado:", error);
                    switch (error.source) {
                      case "guardarBorrador":
                        if (error.status !== 200) {
                          toast.error("Datos inválidos al guardar el borrador. "+error.message);
                        }
                        break;
                      case "cambiarRouter":
                        if (error.status !== 200) {
                          toast.error("Error al cambiar el router. Verifique el estado del router. "+error.message);
                        }
                        break;
                      case "cambiarIPv4":
                        if (error.status !== 200) {
                          toast.error("Error al cambiar IPv4. Comuniquese con el administrador. "+error.message);
                        }
                        break;
                      default:
                        toast.error("Error inesperado. Comuniquese con el administrador. "+error.message);
                    }
                  }
                },
                onClose() {
                  setConfirmDialogIsOpen(false);
                  form.reset({
                    ...form.getValues(),
                    router: null,
                    nap: ordenTrabajo?.nap?.toString() || null,
                    rawNap: ordenTrabajo?.nap_data || null,
                  })
                  setRouterKey(prev => prev + 1);
                },
              });
            }else{
              form.setValue("router","")
            }
            // form.setValue("subtipo_instalacion",null)
          }}
        />

        // :
        // <CustomTextFieldNoForm
        //   label="Router"
        //   value={routersPagingRes?.data?.data?.find((r) => r.codigo === form.getValues().router)?.nombre || 'N/D'}
        //   size={gridSizeMdLg6}
        //   disabled={true}
        // />
      }
      {
        oltsPagingRes?.data?.data?.[0]?.es_bras?
        <>
          <CustomTextFieldNoForm
            label="IP de BRAS"
            value={brasPagingRes?.data?.data?.[0]?.hostname || 'N/D'}
            size={gridSizeMdLg6}
            disabled={true}
          />
        </>
        :
        <CustomTextFieldNoForm
          label="IP de Router"
          // name="router"
          // control={form.control}
          value={routersPagingRes?.data?.data?.find((r) => r.codigo === form.getValues().router)?.ip || 'N/D'}
          shrink={!!routersPagingRes?.data?.data?.find((r) => r.codigo === form.getValues().router)?.ip}
          // error={errors.pppoe as any}
          // helperText={errors.pppoe?.message as any}
          size={gridSizeMdLg6}
          disabled={true}
        />
      }

      {/* -------- Activacion Data -------- */}
      <CustomTextFieldNoForm
        label="IPv4"
        // name="ipv4_actual"
        // control={form.control}
        value={form.getValues()?.ipv4_actual || ''}
        // error={errors.ipv4_actual as any}
        // helperText={errors.ipv4_actual?.message as any}
        size={gridSizeMdLg6}
        disabled={true}
        shrink={true}
      />
      <Grid {...gridSizeMdLg6} item alignContent="center">
        <Button variant="contained" color="primary" fullWidth
        onClick={async()=>{
          setCanChangeNap?.(false)
          try {
            form.setValue("es_borrador",true)
            await guardarBorrador(form.getValues(), false)
            await cambiarIPv4() 
            setRefreshOnt(true)
            setTimeout(() => {
              setRefreshOnt(false)
            }, 1000);
          } catch (error:any) {
            toast.error(error.message);
          }
        }}
        disabled={
          ((watchEstadoNavegacion==EstadosNavegacionEnum.ACTIVO
          || ordenTrabajo?.contrato_data?.estado_navegacion==EstadosNavegacionEnum.ACTIVO)
            && !permitirCambioNapActivo)
          // Traslado ya finalizado (GESTIONADA): queda en solo lectura.
          || (permitirCambioNapActivo
            && watchEstadoActivacion === EstadosActivacionInstallOTEnumChoice.GESTIONADA)
          || !form?.getValues()?.campos_completados?
          true:
          false
        }
        >
          {
            !form.getValues()?.ipv4_actual?
            "Asignar IPv4"
            :
            "Cambiar IPv4"
          }
        </Button>
      </Grid>
      {/* <CustomTextFieldNoForm
        label="Router"
        // name="router"
        // control={form.control}
        value={form.getValues()?.router_data?.nombre || ''}
        shrink={!!form.getValues()?.router_data?.nombre}
        // error={errors.pppoe as any}
        // helperText={errors.pppoe?.message as any}
        size={gridSizeMdLg6}
        disabled={true}
      /> */}
      <CustomTextField
        label="PPPoE"
        name="pppoe"
        control={form.control}
        defaultValue={form.getValues()?.pppoe || ''}
        error={errors.pppoe as any}
        helperText={errors.pppoe?.message as any}
        size={gridSizeMdLg6}
        disabled={true}
        // disabled={form.getValues()?.estado_activacion=="GESTIONADA"?true:false}
      />
      <CustomTextField
        label="PPPassword"
        name="pppassword"
        control={form.control}
        defaultValue={form.getValues()?.pppassword || ''}
        error={errors.pppassword as any}
        helperText={errors.pppassword?.message as any}
        size={gridSizeMdLg6}
        disabled={true}
        // disabled={form.getValues()?.estado_activacion=="GESTIONADA"?true:false}
      />
      <CustomTextField
        name="ssid"
        label="SSID"
        control={form.control}
        defaultValue={form.getValues().ssid || ""}
        error={errors?.ssid as any}
        helperText={errors?.ssid?.message as any}
        size={gridSizeMdLg6}
        disabled={true}
        required={false}
      />
      <CustomTextField
        name="password_wifi"
        label="Password WiFi"
        control={form.control}
        defaultValue={form.getValues().password_wifi || ""}
        error={errors?.password_wifi as any}
        helperText={errors?.password_wifi?.message as any}
        size={gridSizeMdLg6}
        disabled={true}
        required={false}
      />
      <Grid {...gridSizeMdLg12} container item>
        {
          watchEstadoActivacion=="GESTIONADA"
          && watchEquiposUtilizados?.[0]?.name!=ordenTrabajo?.equipos_utilizados?.[0]?.name
          && <CustomAlertCard
            alertTitle="Cambio de ONT"
            alertMessage="Se ha seleccionado un ONT diferente a la seleccionada por activaciones."
            alertColor="warning"
            bgColorAlert="YELLOW"
          />
        }
      </Grid>
      {/* Traslados: decide de donde sale la ONT. Marcado, se busca la que el
          cliente ya tiene instalada (clientes antiguos); desmarcado, sigue el
          flujo de siempre y se le cobra la ONT que se le entregue. */}
      {permitirOntDelCliente && !!onCambiarUsarOntCliente &&
        <Grid {...gridSizeMdLg12} item>
          <Tooltip
            title="El cliente conserva su ONT instalada: se reutiliza esa en vez de entregarle una del stock del tecnico."
            arrow
          >
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={usarOntCliente}
                  disabled={isOnlyView}
                  onChange={(e) => onCambiarUsarOntCliente(e.target.checked)}
                />
              }
              label={<Typography variant="body2">Usar ONT cliente</Typography>}
            />
          </Tooltip>
        </Grid>
      }
      {
        refreshOnt?
        <Grid {...gridSizeMdLg12} container item alignItems="center" justifyContent="center">
          <CircularProgress />
        </Grid>
        :
          <CustomAutocompleteNoForm<ONTOption>
          /* El combo lee su valor con defaultValue, o sea una sola vez al
             montarse. Cuando la ONT se fija desde afuera (la del cliente, en
             traslados) el formulario queda correcto pero el campo se seguia
             viendo vacio. La key lo remonta al cambiar la serie elegida, que
             es el mismo recurso que usa el campo Router mas arriba. */
          key={`ont-${watchEquiposUtilizados?.[0]?.series?.[0] || 'vacio'}`}
          label="ONT a Utilizar"
          // name="ont_a_utilizar"
          valueKey="name"
          actualValueKey="value"
          options={optionsONT || []}
          onChangeRawValue={value => {
            form.reset({
              ...form.getValues(),
              ont_a_utilizar: value,
              equipos_utilizados: [value]
            })
          }}
          isLoadingData={isloadingUbProducto}
          defaultValue={form.getValues().ont_a_utilizar || null}
          size={gridSizeMdLg12}
          /* En TRASLADOS el combo no se bloquea por contrato ACTIVO: el cliente
             sigue navegando mientras se muda y, si no conserva su ONT (perdida,
             dañada o robada), hay que entregarle una del stock y cobrarsela.
             `permitirOntDelCliente` es la prop que solo pasan los traslados.
             Instalaciones y visitas conservan el candado tal cual. */
          disabled={
            !permitirOntDelCliente
            && watchEstadoNavegacion==EstadosNavegacionEnum.ACTIVO
          }
        />
      }

      {/* Buscador de la ONT del cliente: lo abre el check de arriba.

          A diferencia del combo, esto NO se bloquea cuando el contrato esta
          ACTIVO: en un traslado el cliente sigue navegando mientras se muda, y
          lo que se elige aca es su propia ONT. La regla que queda es
          deliberada: a un cliente activo no se le asigna una ONT nueva del
          stock (combo bloqueado), pero si se puede reutilizar la suya. */}
      {permitirOntDelCliente && !!onOntClienteSeleccionada && !!onCerrarDialogoOntCliente &&
        <OntClienteTrasladoDialog
          ordenTrabajo={ordenTrabajo}
          abierto={dialogoOntClienteAbierto}
          onCerrar={onCerrarDialogoOntCliente}
          onOntSeleccionada={onOntClienteSeleccionada}
        />
      }

      {/* Cobro de la ONT entregada: solo cuando NO es la del cliente. */}
      {permitirOntDelCliente && !usarOntCliente && !!onCambiarCobroOnt &&
        <CobroOntNuevaSection
          ont={watchEquiposUtilizados?.[0] || null}
          value={cobroOnt}
          onChange={onCambiarCobroOnt}
          disabled={isOnlyView}
        />
      }

      {/* <CustomAutocompleteNoForm
        label="ONT a utilizar"
        options={[
          {
            nombre: "ONT 1 SERIE #A123",
            codigo: "ONT_1_A123"
          },
          {
            nombre: "ONT 2 SERIE #B123",
            codigo: "ONT_2_B123"
          },
          {
            nombre: "ONT 3 SERIE #C123",
            codigo: "ONT_3_C123"
          }
        ]}
        valueKey="nombre"
        actualValueKey="codigo"
        defaultValue={form.getValues().tipo_instalacion || ""}
        isLoadingData={false}
        onChangeValue={(e) => {
          form.setValue('ont', e)
        }}
      /> */}
      <Grid {...gridSizeMdLg12} container spacing={2} item>
        <Grid {...gridSizeMdLg12} item container>
          <CustomTextFieldNoForm
            label="Hora de Última Activación"
            value={
              watchFechaUltimaActivacion ? 
              dayjs(watchFechaUltimaActivacion).format('DD-MM-YYYY HH:mm:ss') 
              : "No registrada"
            }
            disabled
            size={gridSizeMdLg10}
          />
          <Grid {...gridSizeMdLg2} item container alignItems="center" justifyContent="center">
            <Tooltip title={estadoNavegacionCliente ? form.getValues()?.contrato_data?.estado_navegacion : "Activado"}>
              <span 
              style={{ backgroundColor: 
                watchEstadoNavegacion != EstadosNavegacionEnum.ACTIVO 
                || !watchFechaUltimaActivacion? 
                "#FF0000":"#2FF000" , width: 30, 
              height: 30, borderRadius: "50%" }}/>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid {...gridSizeMdLg6} item alignContent="center">
          {
            !trasladoAprovisionado && (
              estadoNavegacionCliente
              || permitirCambioNapActivo
              || !oltsPagingRes?.data?.data?.[0]?.migrado
            ) && (
              <Button variant="contained" color="primary" fullWidth
                disabled={
                  // Traslado ya finalizado (GESTIONADA): queda en solo lectura.
                  (permitirCambioNapActivo
                    && watchEstadoActivacion === EstadosActivacionInstallOTEnumChoice.GESTIONADA)
                    ? true
                  // Deshabilitado SOLO mientras corre la activacion (evita doble
                  // click). Tras exito/error se re-habilita. Si la OT esta cargada
                  // y NO es activable tambien se deshabilita; en refetch (undefined)
                  // NO se bloquea, para poder reintentar tras un fallo.
                  : activando
                    ? true
                    : (!!ordenTrabajo
                        && ordenTrabajo?.estado_orden_trabajo != EstadosOrdenTrabajoEnumChoice.EN_ESPERA
                        && ordenTrabajo?.estado_orden_trabajo != EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA)
                }
                onClick={() => {
                  procesoActivacion()
                }}
                >
                  {
                    (estadoNavegacionCliente || permitirCambioNapActivo) ? 'ACTIVAR' : 'SUSPENDER'
                  }
              </Button>
            )
          }

        </Grid>
        <Grid {...gridSizeMdLg6} item alignContent="center">
          {
            (estadoNavegacionCliente || permitirCambioNapActivo) && !trasladoAprovisionado &&
            <Button variant="outlined" color="primary" fullWidth
              onClick={() => {
                procesoActivacion(true)
              }}
              disabled={permitirCambioNapActivo
                && watchEstadoActivacion === EstadosActivacionInstallOTEnumChoice.GESTIONADA}
            >
              {
                (estadoNavegacionCliente || permitirCambioNapActivo) ? 'ACTIVAR MANUALMENTE' : 'SUSPENDER MANUALMENTE'
              }
              
            </Button>
          }
        </Grid>

        {/* Traslados: aprovisionar migrando la ONT de la OLT donde esta hoy a
            la del domicilio nuevo. Si no se puede, el propio bloque ofrece la
            activacion de siempre, que es la que usa instalaciones. */}
        {permitirOntDelCliente &&
          <AprovisionarTrasladoSection
            ordenTrabajo={ordenTrabajo}
            onActivarNormal={() => procesoActivacion()}
            disabled={isOnlyView || activando || trasladoAprovisionado
              || watchEstadoActivacion === EstadosActivacionInstallOTEnumChoice.GESTIONADA}
            onAprovisionadoOk={() => {
              // Migración OLT→OLT terminada bien: semáforo verde (persistido).
              const ahora = dayjs().toISOString();
              form.setValue('fecha_ultima_activacion', ahora);
              updateOrdenTrabajo.mutate({
                id: ordenTrabajo?.id_orden_trabajo!,
                data: { fecha_ultima_activacion: ahora } as any,
              });
            }}
          />
        }

      </Grid>
      {
        openClienteContratoData &&
        <ScrollableDialogProps
          open={openClienteContratoData}
          title="Información de Contrato"
          onClose={() => setOpenClienteContratoData(false)}
          width='45%'
          contentNode={<Grid container item {...gridSizeMdLg12}>
            {
              isLoadingClienteContrato?
              <Grid container item {...gridSizeMdLg12} justifyContent={"center"}>
                <CircularProgress/>
              </Grid>
              :(<>
                <Grid container item {...gridSizeMdLg12}>
                  <Typography>Puerto Cliente: {form.getValues()?.puertoEnNap?.puerto || "No asignado"}</Typography>
                </Grid>
                <Grid container item {...gridSizeMdLg12}>
                  <Typography>Cliente: {dataClienteContrato?.data?.prospecto_data?.razon_social}</Typography>
                </Grid>
                <Grid container item {...gridSizeMdLg6}>
                  <Typography>Identificación: {dataClienteContrato?.data?.prospecto_data?.identificacion}</Typography>
                </Grid>
              </>)
            }
          </Grid>}
          showRejectBtn={false}
          showConfirmBtn={false}
          onConfirm={()=>setOpenClienteContratoData(false)}
        />
      }


      <ModalProgressActivacion
        open={openModalProgress}
        setOpen={setOpenModalProgress}
        taskStatus={estadoDeAprovisionamiento}
      />

    </>
  );
};

export default DatosTecnicosFormComponentActivaciones;
